module.exports = __webpack_public_path__ + "static/volunteer_profile2@2x-821cf5a69e5c5bacfacc218091ed039a.png";